@if (InPatientGender?.count! > 0) {
  <div id="divChart" class="chart-container"
    [ngClass]="{ 'not-pre-registration': !isPreRegistration, 'pre-registration': isPreRegistration }">
    <canvas id="admissionsGender"> </canvas>
  </div>
}